import api from "../api.js";

/**
 * Point of Sale - Device service
 *
 * Enables API interactions with PoS device records.
 */
class PosDeviceService {

	/**
	 * Get a PoS device's registration data by its device token.
	 *
	 * @param {String} deviceToken
	 * @return {Promise}
	 */
	static getDeviceRegistration(deviceToken) {
		return api.call({url: `/api/pos/devices/${deviceToken}/registration`}).then(({data}) => data);
	}

}

export default PosDeviceService;
